export enum RequestRestorePasswordState {
    FillInEmail,
    SendingEmail,
    SendedEmail,
    SendEmailFail,
}
